export default __webpack_public_path__ + "audio-classificationd9c345.png";